import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import FloatingContact from "@/components/FloatingContact.vue";
import avatar from "../assets/contact-male-avatar.png";
import Tabs from "@/components/Tabs/index.vue";
import TabPanel from "../components/Tabs/TabPanel.vue";
import { ref } from "vue";
import { LicenseList as LicenseListType } from "@/data/index.type";
import banner02 from "../assets/banner-02.png";
import banner03 from "../assets/banner-03.jpg";
import LicenseQuery from "@/components/LicenseQuery.vue";
import CooperactionChannel from "@/components/CooperactionChannel.vue";
import LicenseToken from "@/components/LicenseToken.vue";
import Banner from "@/components/Banner.vue";
import { computed } from "@vue/reactivity";
import type { BannerProps } from "@/components/Banner.vue";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'License',
  setup(__props) {

const tabsRef = ref<InstanceType<typeof Tabs>>();
const store = useStore();

const activeIndex = computed(() => {
  if (tabsRef.value === undefined) return 0;
  return tabsRef.value?.getIndex();
});

const banners: Partial<BannerProps[]> = [
  {
    src: banner02,
    href: "https://www.ccq.com/",
  },
  {
    src: banner03,
    href: "https://www.ccq.com/",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Banner, {
      src: "https://www.szjfjt.com/images/fbz.jpg",
      href: "https://www.fbz.com/",
      style: {"min-height":"80px"},
      show: ""
    }),
    _createVNode(Tabs, {
      ref_key: "tabsRef",
      ref: tabsRef
    }, {
      default: _withCtx(() => [
        _createVNode(TabPanel, {
          title: "正版许可查询",
          banner: _unref(banner03)
        }, {
          default: _withCtx(() => [
            _createVNode(LicenseQuery)
          ]),
          _: 1
        }, 8, ["banner"]),
        _createVNode(TabPanel, { title: "官方合作通道" }, {
          default: _withCtx(() => [
            _createVNode(CooperactionChannel)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    (_unref(store).state.contacts)
      ? (_openBlock(), _createBlock(FloatingContact, {
          key: 0,
          title: "官方合作",
          qq: _unref(store).state.contacts[1],
          avatar: _unref(avatar)
        }, null, 8, ["qq", "avatar"]))
      : _createCommentVNode("", true),
    _createVNode(LicenseToken)
  ], 64))
}
}

})